export default {
  name: 'TableHeaderSorting',
  components: {},
  props: {
    descending: false,
  },
  data: () => ({}),
  computed: {},
  methods: {},
};
